import { CHANGED_LANGUAGE_ERROR, CHANGED_LANGUAGE_SUCCESS, UserSettingsActionTypes } from './types';
import { AppState } from '../index';

export interface UserSettingsState {
    changedLanguageSuccess: boolean;
    error?: Error;
}
export const INITIAL_STATE: UserSettingsState = {
    changedLanguageSuccess: false,
};
export default function(state = INITIAL_STATE, action: UserSettingsActionTypes) {
    switch (action.type) {
        case CHANGED_LANGUAGE_SUCCESS:
            const { changedLanguageSuccess } = action.payload;
            return { ...state, changedLanguageSuccess };
        case CHANGED_LANGUAGE_ERROR:
            return { ...state, error: action.error, changedLanguageSuccess: false };
        default:
            return state;
    }
}
export const selectChangedLanguageSuccess = (state: AppState): boolean | undefined =>
    state.userSettings.changedLanguageSuccess;
export const selectChangedLanguageError = (state: AppState): Error | undefined => state.userSettings.error;
